module.exports = __webpack_public_path__ + "static/motion-cares-logo-b080f250311d8a834ba2b7e75c93d5e5.jpeg";